import {
  fieldStaticIPRequired,
  fieldStaticIPRequiredFibre,
  fieldRegularYearlyOffersFibre,
  fieldQualifiedSpeedFibre,
  fieldTermFibre,
  fieldRegularMonthlyOffersFibre,
  fieldRegularYearlyOffersFibreBundled,
  fieldTwoMonthsFreeFibre,
  fieldLimitedMonthlyOfferFibre,
  fieldLimitedMonthlyOfferFibre75,
  fieldLimitedYearlyOffersFibre,
  fieldLimitedMontlyOfferFibre3G,
  fieldLimitedYearlyOffersFibre150,
  fieldLimitedYearlyOffersFibre300,
  fieldFiberInternetG1promo,
  twoMonthsFreeFibre,
  BACKEND_KEYS,
  numberTelusWifiAccessPointsFibre,
  numberTelusAccessPoints,
  telusPublicWifiFibre,
  fieldProductSelectionFibre,
  fieldTelusBusinessWifiOption,
  valueQualifiedSpeed940mbps,
  keySecureBusiness,
  fieldMobility,
  fieldBusinessConnect,
  fieldLimitedTimeOfferYearly15g,
  fieldLimitedOfferFI,
  fieldFiberInternet75G1,
  fieldFibreInternet75G2,
  fieldFibreInternet75MPP,
  productSelection,
  fiveYearlyFibrePromos,
  valueTerm60Month,
  fiveDollarsOff,
  sixMonthsFree,
  sixMonthsFreePromo,
  blackFridayPromos,
  switchCredit$100,
  switchCreditValue,
  valueTerm36Month,
  valueQualifiedSpeed15gFibre,
  valueQualifiedSpeed3gFibre,
  fieldStaticIpSubnet1,
  fieldStaticIpSubnet5,
  fieldStaticIp5,
  billCredit100,
  internetAndBusinessConnectBundleBillCredit200,
  fieldLimitedTimeOfferYearly3g3000,
  contractBuyoutBillCredit300,
  contractBuyoutBillCredit600,
  fieldMppOffers,
  mppCrossSellOffer15,
  mppFibreInternet1G,
  fieldOptionStaticIpDynamic5,
  fieldOptionStaticIp0,
  fieldLimitedYearlyOffersFibreFiveG,
  valueOptionFibreInternet5GPromo,
  fieldStaticIpPromotionFibre,
  staticIp5LabelPromotion,
  britishColumbia,
  alberta,
  ab,
  bc
} from '../../../utils/constant';
import { getLocalizedStrings, getLocale } from '../../../misc';
import { internetFibreRates } from '../../businessLogic/rates';
import getFieldValue from './getFieldValue';
import { getFieldPriceOrLabel } from './secureBusiness';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';
import request from '../../../utils/request';

export default (fields, steps) => {
  const {
    contentfulValues: {
      valueTwoMonthsFree,
      yes,
      yearsTerm,
      threeMonthsFree,
      // bundled,
      bundledOffer,
      standaloneOffer,
      monthly,
      monthPromo,
      valueThreeYearLtoPromo,
      valueFibreInternet15gPromo,
      mbps150,
      mbps300,
      mbps15G,
      mbps1G
    }
  } = getLocalizedStrings();

  const locale = getLocale();

  const {
    WLS: {
      _managersSpecialDiscount,
      partnerDiscount,
      _billCredit100,
      _internetAndBusinessConnectBundleBillCredit200,
      _contractBuyoutBillCredit300,
      _contractBuyoutBillCredit600,
      _6monthsFree,
      _valueTerm60Month,
      _valueTerm36Month,
      _bundled,
      businessConnect,
      secureBusiness,
      mobility,
      telusBusinessWifi
    }
  } = locale === 'en-US' ? EN : FR;

  const {
    fields: { formStepFields }
  } = steps.find(s => s.fields.backendKey === BACKEND_KEYS.officeInternetFiber);

  let staticIPRate = 0;
  let speedRate = 0;
  let promoDiscount = 0;
  let wifiAccessMonthly = 0;
  let wifiAccessOneTime = 0;
  let creditDiscount = 0;
  let managerSpecialDiscount = 0;
  let bundlePriceForAlbertaBC = 0;
  const product = {
    limitedTimeOffers: [],
    regularOffers: [],
    wifiAccess: [],
    bundledOffers: [],
    fiveYearlyPromo: [],
    blackFridayPromo: [],
    switchCreditPromo: []
  };
  const valueStaticIP = getFieldValue(fieldStaticIPRequiredFibre, fields); 
  const valueStaticIpPromotion = getFieldValue(fieldStaticIpPromotionFibre, fields); 

  const valueQualifiedSpeed = getFieldValue(fieldQualifiedSpeedFibre, fields);
  const valueTerm = getFieldValue(fieldTermFibre, fields);
  const valueRegularMonthlyPromo = getFieldValue(
    fieldRegularMonthlyOffersFibre,
    fields
  );
  const valueRegularYearlyPromo = getFieldValue(
    fieldRegularYearlyOffersFibre,
    fields
  );
  const valueRegularYearlyPromoBundled = getFieldValue(
    fieldRegularYearlyOffersFibreBundled,
    fields
  );
  const fiveYearlyPromosValue = getFieldValue(fiveYearlyFibrePromos, fields);
  const blackFridayPromoValue = getFieldValue(blackFridayPromos, fields);
  const switchCreditPromoValue = getFieldValue(switchCredit$100, fields);
  const valueTwoMonthsPromo = getFieldValue(fieldTwoMonthsFreeFibre, fields);
  const valueManagerSpecial = getFieldValue('fiberManagerSpecial', fields);
  const valueManagerSpecialAB = getFieldValue('fiberManagerSpecialAB', fields);
  const valueLimitedMonthlyOffer = getFieldValue(
    fieldLimitedMonthlyOfferFibre,
    fields
  );
  const valueLimitedMonthlyOffer75 = getFieldValue(
    fieldLimitedMonthlyOfferFibre75,
    fields
  );
  const valueLimitedOfferFI = getFieldValue(fieldLimitedOfferFI, fields);
  const valueLimitedYearlyOffer = getFieldValue(
    fieldLimitedYearlyOffersFibre,
    fields
  );
  const valueLimitedMonthlyOffer3 = getFieldValue(
    fieldLimitedMontlyOfferFibre3G,
    fields
  );
  const valueLimitedYearlyOffersFibre150 = getFieldValue(
    fieldLimitedYearlyOffersFibre150,
    fields
  );
  const valuelimitedYearlyOffersFibreAlbertaBC = getFieldValue(
    'limitedYearlyOffersFibreAlbertaBC',
    fields
  )
  const valuelimitedTimeOfferYearly15gAlbertaBC = getFieldValue(
    'limitedTimeOfferYearly15gAlbertaBC',
    fields
  )
  const valuelimitedTimeOfferYearly3g_3000AlbertaBC = getFieldValue(
    'limitedTimeOfferYearly3g_3000AlbertaBC',
    fields
  )
  const valueLimitedYearlyOffersFibre300 = getFieldValue(
    fieldLimitedYearlyOffersFibre300,
    fields
  );
  const valueLimitedYearlyOffersFibre3G = getFieldValue(
    fieldLimitedTimeOfferYearly3g3000,
    fields
  );
  const valueNumberTelusWifiAccessPoints = getFieldValue(
    numberTelusWifiAccessPointsFibre,
    fields
  );
  const valueNumberTelusAccessPoints = getFieldValue(
    numberTelusAccessPoints,
    fields
  );
  const valueTelusPublicWifiFibre = getFieldValue(telusPublicWifiFibre, fields);
  const valueProductSelectionFibre = getFieldValue(
    fieldProductSelectionFibre,
    fields
  );

  const valueMppOffer = getFieldValue(fieldMppOffers, fields);

  const isLimitedOfferSelected =
    valueLimitedMonthlyOffer ||
    valueLimitedMonthlyOffer75 ||
    valueLimitedYearlyOffer;

  const allFreePromos = [valueLimitedMonthlyOffer75, valueLimitedMonthlyOffer];
  const freePromoIndex = allFreePromos.indexOf(threeMonthsFree);

  const freePromoValue =
    allFreePromos[freePromoIndex] ||
    (valueTwoMonthsPromo === yes && valueTwoMonthsFree);
  const isAnyFreePromoSelected = freePromoValue || valueTwoMonthsPromo === yes;
  const validProvinces = [britishColumbia, alberta, ab, bc];

  const {
    monthlyRates,
    yearlyRates,
    yearlyRatesAlbertaBC,
    yearlyRatesBundleDiscounts,
    yearlyRatesBundleDiscountsForQuebec,
    yearlyRatesQuebec,
    yearlyRatesBundledWifiQuebec,
    yearlyRatesBundledForWifiQuebec,
    yearlyRatesBundleDiscountsQuebec,
    yearlyRatesStandaloneDiscountsForQuebec,
    fibreInternet3gPromoDiscount,
    yearlyRatesFibreWithBusinessWifiBundleDiscounts,
    regularOffers: {
      monthPromo: regularMonthlyPromos,
      yearlyPromo: regularYearlyPromos,
      yearlyStandalonePromo,
      yearlyLimited3GPromo
    },
    limitedMonthlyOffers,
    threeYearLtoPromoDiscount: threeYearLtoPromoDiscountPrice,
    fibreInternet15gPromoDiscount: fibreInternet15gPromoDiscountPrice,
    limitedYearlyOffersFibre150,
    limitedYearlyOffersFibre300,
    limitedOfferFI,
    limitedYearlyOffersFibreStandalone,
    limitedYearlyOffersFibreBundled,
    limitedYearlyOffers15G,
    limitedproductSelection,
    threeYearBusinessWifiRates,
    fiveYearBusinessWifiRates,
    billCredit100: billCredit100Rate,
    billCredit200: billCredit200Rate,
    buyoutBillCredit300: buyoutBillCredit300Rate,
    buyoutBillCredit600: buyoutBillCredit600Rate,
    yearlyFibreMppDiscounts,
    fibreInternet5gPromoDiscount
  } = internetFibreRates;

  let threeYearLtoPromoDiscount = 0;
  let fibreInternet15gPromoDiscount = 0;
  const valueLimitedTimeOfferYearly15g = getFieldValue(
    fieldLimitedTimeOfferYearly15g,
    fields
  );
  const valueLimitedYearlyOffersFibreFiveG = getFieldValue(
    fieldLimitedYearlyOffersFibreFiveG,
    fields
  );

  if (valueLimitedTimeOfferYearly15g) {
    if (valueLimitedTimeOfferYearly15g === valueThreeYearLtoPromo) {
      threeYearLtoPromoDiscount += threeYearLtoPromoDiscountPrice;
      product.regularOffers.push({
        value: getFieldPriceOrLabel(
          formStepFields,
          fieldLimitedTimeOfferYearly15g,
          false
        ),
        qty: 1,
        prices: {
          monthly: threeYearLtoPromoDiscount,
          oneTime: 0
        }
      });
    } else if (valueLimitedTimeOfferYearly15g === valueFibreInternet15gPromo) {
      fibreInternet15gPromoDiscount += fibreInternet15gPromoDiscountPrice;
      product.regularOffers.push({
        value: getFieldPriceOrLabel(
          formStepFields,
          fieldLimitedTimeOfferYearly15g,
          false
        ),
        qty: 1,
        prices: {
          monthly: fibreInternet15gPromoDiscount,
          oneTime: 0
        }
      });
    } else {
      product.limitedTimeOffers.push({
        value: getFieldPriceOrLabel(
          formStepFields,
          valueLimitedTimeOfferYearly15g,
          false
        ),
        qty: 1,
        prices: {
          monthly: -limitedYearlyOffers15G[valueLimitedTimeOfferYearly15g],
          oneTime: 0
        }
      });
      promoDiscount += limitedYearlyOffers15G[valueLimitedTimeOfferYearly15g];
    }
  }

  if (valueStaticIP === yes) {
    staticIPRate = internetFibreRates[fieldStaticIPRequired];
    product.staticIp = {
      value: getFieldPriceOrLabel(formStepFields, valueStaticIP, false),
      qty: 5,
      prices: {
        monthly: staticIPRate,
        oneTime: 0
      }
    };
  }
  if (valueStaticIP === fieldStaticIpSubnet1) {
    staticIPRate = internetFibreRates[fieldStaticIpSubnet1];
    product.staticIp = {
      value: getFieldPriceOrLabel(formStepFields, valueStaticIP, false),
      qty: 1,
      prices: {
        monthly: staticIPRate,
        oneTime: 0
      }
    };
  }
  
  if (valueStaticIP === fieldOptionStaticIpDynamic5) {
    staticIPRate = internetFibreRates[fieldOptionStaticIpDynamic5];
    product.staticIp = {
      value: getFieldPriceOrLabel(formStepFields, valueStaticIP, false),
      qty: 1,
      prices: {
        monthly: staticIPRate,
        oneTime: 0
      }
    };
  }
  if (valueStaticIP === fieldOptionStaticIp0) {
    staticIPRate = internetFibreRates[fieldOptionStaticIp0];
    product.staticIp = {
      value: getFieldPriceOrLabel(formStepFields, valueStaticIP, false),
      qty: 1,
      prices: {
        monthly: staticIPRate,
        oneTime: 0
      }
    };
  }

  if (valueStaticIP === fieldStaticIp5) {
    staticIPRate = internetFibreRates[fieldStaticIp5];
    product.staticIp = {
      value: getFieldPriceOrLabel(formStepFields, valueStaticIP, false),
      qty: 1,
      prices: {
        monthly: staticIPRate,
        oneTime: 0
      }
    };
  }
  if (
    valueStaticIP === fieldStaticIpSubnet5 &&
    !(
      [
        valueQualifiedSpeed15gFibre,
        'Fibre Internet 3G: 3G/3GMbps',
        '3G/3000 mbps'
      ].includes(valueQualifiedSpeed) &&
      !['QC'].includes(request.getProvince())
    )
  ) {
    staticIPRate = internetFibreRates[fieldStaticIpSubnet5];
    product.staticIp = {
      value: getFieldPriceOrLabel(formStepFields, valueStaticIP, false),
      qty: 5,
      prices: {
        monthly: staticIPRate,
        oneTime: 0
      }
    };
  }
   // Shows Static Ip Promotion on quote summary page
   if (valueStaticIpPromotion === staticIp5LabelPromotion) {
    staticIPRate -= 20;
     product.staticIpPromotion = {
       value: getFieldPriceOrLabel(formStepFields, valueStaticIpPromotion, false),
       qty: 1,
       prices: {
         monthly: -20,
         oneTime: 0
       }
     };
   }

  if (valueTelusPublicWifiFibre !== yes) {
    if (
      valueTerm === _valueTerm36Month &&
      valueQualifiedSpeed === valueQualifiedSpeed940mbps &&
      valueRegularYearlyPromoBundled === standaloneOffer &&
      valueNumberTelusWifiAccessPoints > 0
    ) {
      product.wifiAccess.push({
        value: getFieldPriceOrLabel(
          formStepFields,
          numberTelusWifiAccessPointsFibre,
          false
        ),
        qty: valueNumberTelusWifiAccessPoints,
        prices: {
          monthly: +(valueNumberTelusWifiAccessPoints * 0),
          oneTime: 0
        }
      });
    } else if (valueNumberTelusWifiAccessPoints > 0) {
      product.wifiAccess.push({
        value: getFieldPriceOrLabel(
          formStepFields,
          numberTelusWifiAccessPointsFibre,
          false
        ),
        qty: valueNumberTelusWifiAccessPoints,
        prices: {
          monthly: +(valueNumberTelusWifiAccessPoints * 15),
          oneTime: 0
        }
      });
    }

    // const showAccessPoint = localStorage.getItem('showAccessPoint')
    //   ? localStorage.getItem('showAccessPoint')
    //   : null;
    // // Show TELUS Business Wi-Fi Access Points only when showAccessPoint is true
    // // This is controlled from formStep profile && profile.dealership logic
    // if (showAccessPoint !== 'false') {
    //   product.wifiAccess.push({
    //     value: getFieldPriceOrLabel(formStepFields, numberTelusWifiAccessPointsFibre, false),
    //     qty: valueNumberTelusAccessPoints,
    //     prices: {
    //       monthly: +((valueNumberTelusAccessPoints) * 15),
    //       oneTime: valueNumberTelusAccessPoints > 1 ? 75 : 0
    //     }
    //   });
    // }
  } else {
    product.wifiAccess = [];
    wifiAccessMonthly = 0;
    wifiAccessOneTime = 0;
  }

  if (valueTerm === monthly) {
    if (valueQualifiedSpeed) {
      speedRate = monthlyRates[valueQualifiedSpeed];
      if (valueRegularMonthlyPromo === monthPromo && !isAnyFreePromoSelected) {
        product.regularOffers.push({
          value: getFieldPriceOrLabel(formStepFields, monthPromo, false),
          qty: 1,
          prices: {
            monthly: -regularMonthlyPromos[valueQualifiedSpeed],
            oneTime: 0
          }
        });
        promoDiscount += regularMonthlyPromos[valueQualifiedSpeed];
      }

      if (isAnyFreePromoSelected) {
        if (fields.twoMonthsFreeFibre && fields.twoMonthsFreeFibre === yes) {
          product.regularOffers.push({
            value: getFieldPriceOrLabel(
              formStepFields,
              twoMonthsFreeFibre,
              false
            ),
            qty: 1,
            prices: {
              monthly: -monthlyRates[valueQualifiedSpeed],
              oneTime: 0
            }
          });
        } else {
          product.limitedTimeOffers.push({
            value: getFieldPriceOrLabel(formStepFields, freePromoValue, false),
            qty: 1,
            prices: {
              monthly: -monthlyRates[valueQualifiedSpeed],
              oneTime: 0
            }
          });
        }
        promoDiscount += monthlyRates[valueQualifiedSpeed];
      }
      if (
        isLimitedOfferSelected &&
        (valueLimitedMonthlyOffer || valueLimitedMonthlyOffer75) &&
        !isAnyFreePromoSelected
      ) {
        product.limitedTimeOffers.push({
          value: getFieldPriceOrLabel(
            formStepFields,
            valueLimitedMonthlyOffer || valueLimitedMonthlyOffer75,
            false
          ),
          qty: 1,
          prices: {
            monthly: -limitedMonthlyOffers[valueQualifiedSpeed],
            oneTime: 0
          }
        });
        promoDiscount += limitedMonthlyOffers[valueQualifiedSpeed];
      }
    }
  }
  if (valueTerm !== monthly) {
    if (valueQualifiedSpeed) {
      if(!validProvinces.includes(request.getProvince())){
      speedRate = yearlyRates[valueQualifiedSpeed];
      if (valueRegularYearlyPromoBundled === _bundled) {
        speedRate =
          yearlyRates[valueQualifiedSpeed] -
          yearlyRatesBundleDiscounts[valueQualifiedSpeed];

        if (['QC'].includes(request.getProvince())) {
          if ([mbps150, mbps300, mbps1G].includes(valueQualifiedSpeed)) {
              // Default case with bundle discount
              speedRate =
                yearlyRatesQuebec[valueQualifiedSpeed] -
                yearlyRatesBundleDiscountsQuebec[valueQualifiedSpeed];
          }
        }
      }
      else if (
        valueRegularYearlyPromoBundled === standaloneOffer &&
        ['QC'].includes(request.getProvince())
      ) {
        speedRate =
          yearlyRatesQuebec[valueQualifiedSpeed];
      }
      } else{
        speedRate = yearlyRatesAlbertaBC[valueTerm][valueQualifiedSpeed];
      }  
    }

    if (valueRegularYearlyPromoBundled === _bundled) {
      if (['QC'].includes(request.getProvince())) {
        if ([mbps150, mbps300, mbps1G].includes(valueQualifiedSpeed)) {
          if (valueProductSelectionFibre && valueProductSelectionFibre.length > 0) {
            const isBusinessWifiSelected = valueProductSelectionFibre.includes('Telus Business Wi-Fi');       
            const additionalSelectedProducts = valueProductSelectionFibre.filter(product => 
              [businessConnect, secureBusiness, mobility].includes(product)
            );
            if (isBusinessWifiSelected) {
              promoDiscount += 15;
              product.bundledOffers.push({
                value: "Bundled Business Wi-Fi",
                qty: 1,
                prices: {
                  monthly: -15,
                  oneTime: 0
                }
              });
            }     
            if (additionalSelectedProducts.length > 0) {
              promoDiscount += 10;
              product.bundledOffers.push({
                value: getFieldPriceOrLabel(
                  formStepFields, 
                  valueRegularYearlyPromoBundled, 
                  false
                ),
                qty: 1,
                prices: {
                  monthly: -10,
                  oneTime: 0
                }
              });
            }
          }
        }
      } else if (!validProvinces.includes(request.getProvince())) {
        if (
          valueProductSelectionFibre &&
          valueProductSelectionFibre.includes(fieldTelusBusinessWifiOption) &&
          valueProductSelectionFibre.includes('Mobility')
        ) {
          if (valueQualifiedSpeed === '3G/3000 mbps') {
            if (valueTerm === _valueTerm36Month) {
              promoDiscount += 145;
              product.bundledOffers.push({
                value: getFieldPriceOrLabel(
                  formStepFields,
                  valueRegularYearlyPromoBundled,
                  false
                ),
                qty: 1,
                prices: {
                  monthly: 145,
                  oneTime: 0
                }
              });
            } else {
              promoDiscount += 135;
              product.bundledOffers.push({
                value: getFieldPriceOrLabel(
                  formStepFields,
                  valueRegularYearlyPromoBundled,
                  false
                ),
                qty: 1,
                prices: {
                  monthly: 135,
                  oneTime: 0
                }
              });
            }
          } else if (valueQualifiedSpeed === mbps15G) {
            if (valueTerm === _valueTerm36Month) {
              promoDiscount += 25;
              product.bundledOffers.push({
                value: getFieldPriceOrLabel(
                  formStepFields,
                  valueRegularYearlyPromoBundled,
                  false
                ),
                qty: 1,
                prices: {
                  monthly: 25,
                  oneTime: 0
                }
              });
            } else {
              promoDiscount += 15;
              product.bundledOffers.push({
                value: getFieldPriceOrLabel(
                  formStepFields,
                  valueRegularYearlyPromoBundled,
                  false
                ),
                qty: 1,
                prices: {
                  monthly: 15,
                  oneTime: 0
                }
              });
            }
          } else if (valueQualifiedSpeed === mbps1G) {
            if (valueTerm === _valueTerm60Month) {
              promoDiscount += 10;
              product.bundledOffers.push({
                value: getFieldPriceOrLabel(
                  formStepFields,
                  valueRegularYearlyPromoBundled,
                  false
                ),
                qty: 1,
                prices: {
                  monthly: 10,
                  oneTime: 0
                }
              });
            }
          }
        } else if (
          valueProductSelectionFibre &&
          valueProductSelectionFibre.includes(fieldTelusBusinessWifiOption) &&
          !['QC'].includes(request.getProvince())
        ) {
          promoDiscount +=
            yearlyRatesFibreWithBusinessWifiBundleDiscounts[valueTerm][
              valueQualifiedSpeed
            ];
          product.bundledOffers.push({
            value: getFieldPriceOrLabel(
              formStepFields,
              valueRegularYearlyPromoBundled,
              false
            ),
            qty: 1,
            prices: {
              monthly: -yearlyRatesFibreWithBusinessWifiBundleDiscounts[
                valueTerm
              ][valueQualifiedSpeed],
              oneTime: 0
            }
          });
        } else if (!['QC'].includes(request.getProvince())) {
          promoDiscount += yearlyRatesBundleDiscounts[valueQualifiedSpeed];
          product.bundledOffers.push({
            value: getFieldPriceOrLabel(
              formStepFields,
              valueRegularYearlyPromoBundled,
              false
            ),
            qty: 1,
            prices: {
              monthly: -yearlyRatesBundleDiscounts[valueQualifiedSpeed],
              oneTime: 0
            }
          });
        }
      } else {
        if (valueProductSelectionFibre.includes(businessConnect)) {
          bundlePriceForAlbertaBC = bundlePriceForAlbertaBC - 10;
        } else if (valueProductSelectionFibre.includes(secureBusiness)) {
          bundlePriceForAlbertaBC = bundlePriceForAlbertaBC - 10;
        } else if (valueProductSelectionFibre.includes(mobility)) {
          bundlePriceForAlbertaBC = bundlePriceForAlbertaBC - 10;
        } else if (
          valueProductSelectionFibre.includes(telusBusinessWifi) &&
          (valueProductSelectionFibre.includes(secureBusiness) ||
            valueProductSelectionFibre.includes(businessConnect) ||
            valueProductSelectionFibre.includes(mobility))
        ) {
          bundlePriceForAlbertaBC = bundlePriceForAlbertaBC - 10;
        }

        if (valueProductSelectionFibre.includes(telusBusinessWifi)) {
          bundlePriceForAlbertaBC = bundlePriceForAlbertaBC - 15;
        }

        promoDiscount -= bundlePriceForAlbertaBC;
        product.bundledOffers.push({
          value: getFieldPriceOrLabel(
            formStepFields,
            valueRegularYearlyPromoBundled,
            false
          ),
          qty: 1,
          prices: {
            monthly: bundlePriceForAlbertaBC,
            oneTime: 0
          }
        });
      }
    }
    if (
      valueLimitedYearlyOffersFibre3G &&
      valueProductSelectionFibre &&
      !valueProductSelectionFibre.includes(fieldTelusBusinessWifiOption)
    ) {
      // For standalone 3g promo selection
      promoDiscount += -fibreInternet3gPromoDiscount;
      product.bundledOffers.push({
        value: getFieldPriceOrLabel(
          formStepFields,
          valueRegularYearlyPromoBundled,
          false
        ),
        qty: 1,
        prices: {
          monthly: fibreInternet3gPromoDiscount,
          oneTime: 0
        }
      });
    }

    if (valueTerm === _valueTerm60Month && valueLimitedYearlyOffersFibre3G) {
      // fibreInternet3gPromoDiscount +=
      //   internetFibreRates.fibreInternet3gPromoDiscount - 20;
      promoDiscount += -fibreInternet3gPromoDiscount + 20;
      product.limitedTimeOffers.push({
        value: getFieldPriceOrLabel(
          formStepFields,
          valueLimitedYearlyOffersFibre3G,
          false
        ),
        qty: 1,
        prices: {
          monthly: fibreInternet3gPromoDiscount - 20,
          oneTime: 0
        }
      });
    } else if (valueLimitedYearlyOffersFibre3G) {
      // fibreInternet3gPromoDiscount +=
      //   internetFibreRates.fibreInternet3gPromoDiscount;
      promoDiscount += -fibreInternet3gPromoDiscount;
      product.limitedTimeOffers.push({
        value: getFieldPriceOrLabel(
          formStepFields,
          valueLimitedYearlyOffersFibre3G,
          false
        ),
        qty: 1,
        prices: {
          monthly: fibreInternet3gPromoDiscount,
          oneTime: 0
        }
      });
    }
    //Switch Credit $100 Promo Fibre
    // if (
    //   valueRegularYearlyPromoBundled &&
    //   switchCreditPromoValue === switchCreditValue
    // ) {
    //   product.switchCreditPromo.push({
    //     value: '$100 Switch Credit ',
    //     qty: '',
    //     prices: {
    //       monthly: -100,
    //       oneTime: ''
    //     }
    //   });
    // }

    if (
      valueRegularYearlyPromoBundled &&
      switchCreditPromoValue === _billCredit100
    ) {
      creditDiscount += billCredit100Rate;
      product.switchCreditPromo.push({
        value: _billCredit100,
        qty: '',
        prices: {
          monthly: 0,
          oneTime: billCredit100Rate
        }
      });
    }

    if (
      valueRegularYearlyPromoBundled &&
      switchCreditPromoValue === internetAndBusinessConnectBundleBillCredit200
    ) {
      creditDiscount += billCredit200Rate;
      product.switchCreditPromo.push({
        value: _internetAndBusinessConnectBundleBillCredit200,
        qty: '',
        prices: {
          monthly: 0,
          oneTime: billCredit200Rate
        }
      });
    }
    if (
      valueRegularYearlyPromoBundled &&
      switchCreditPromoValue === contractBuyoutBillCredit300
    ) {
      creditDiscount += buyoutBillCredit300Rate;
      product.switchCreditPromo.push({
        value: _contractBuyoutBillCredit300,
        qty: '',
        prices: {
          monthly: 0,
          oneTime: buyoutBillCredit300Rate
        }
      });
    }
    if (
      valueRegularYearlyPromoBundled &&
      switchCreditPromoValue === contractBuyoutBillCredit600
    ) {
      creditDiscount += buyoutBillCredit600Rate;
      product.switchCreditPromo.push({
        value: _contractBuyoutBillCredit600,
        qty: '',
        prices: {
          monthly: 0,
          oneTime: buyoutBillCredit600Rate
        }
      });
    }

    if (
      valueTerm === _valueTerm60Month &&
      fiveYearlyPromosValue === fiveDollarsOff
    ) {
      promoDiscount += 5;
      product.fiveYearlyPromo.push({
        value: fiveDollarsOff,
        qty: 1,
        prices: {
          monthly: -5,
          oneTime: 0
        }
      });
    }
    if (
      valueTerm === _valueTerm60Month &&
      fiveYearlyPromosValue == _6monthsFree
    ) {
      product.fiveYearlyPromo.push({
        value: _6monthsFree,
        qty: 1,
        prices: {
          monthly: 0,
          oneTime: 0
        }
      });
    }

    if (
      valueManagerSpecial === 'managerspecial$5' &&
      valueRegularYearlyPromoBundled === _bundled &&
      valueProductSelectionFibre.includes('Telus Business Wi-Fi') &&
      !valueProductSelectionFibre.includes('Secure Business') &&
      !valueProductSelectionFibre.includes('Business Connect') &&
      !validProvinces.includes(request.getProvince()) &&
      !(valueTerm === _valueTerm60Month || valueTerm === _valueTerm36Month) &&
      valueQualifiedSpeed === mbps1G &&
      valueRegularYearlyPromoBundled === _bundled &&
      ['QC'].includes(request.getProvince())
    ) {
      product.regularOffers.push({
        value: _managersSpecialDiscount,
        qty: 1,
        prices: {
          monthly: -5,
          oneTime: 0
        }
      });

      managerSpecialDiscount = 5;
    } else if (
      valueManagerSpecial === 'managerspecial$5' &&
      valueRegularYearlyPromoBundled === standaloneOffer &&
      !validProvinces.includes(request.getProvince())
    ) {
      product.regularOffers.push({
        value: _managersSpecialDiscount,
        qty: 1,
        prices: {
          monthly: -5,
          oneTime: 0
        }
      });
      managerSpecialDiscount = 5;
    }

    if (
      valueManagerSpecial === 'managerspecial$5' &&
      (valueTerm === _valueTerm60Month || valueTerm === _valueTerm36Month) &&
      valueQualifiedSpeed === mbps1G &&
      valueRegularYearlyPromoBundled === _bundled &&
      ['QC'].includes(request.getProvince())
    ) {
      if (valueProductSelectionFibre.includes('Mobility')) {
        product.regularOffers.push({
          value: _managersSpecialDiscount,
          qty: 1,
          prices: {
            monthly: -5,
            oneTime: 0
          }
        });        
        managerSpecialDiscount = 5;
      }
    }
    
    if (
      valueManagerSpecial === 'managerspecial$5' &&
      (valueTerm === _valueTerm60Month || valueTerm === _valueTerm36Month) &&
      [
        mbps1G,
        mbps15G,
        'Fibre Internet 3G: 3G/3GMbps',
        '3G/3000 mbps'
      ].includes(valueQualifiedSpeed) &&
      valueRegularYearlyPromoBundled === _bundled &&
      validProvinces.includes(request.getProvince())
    ) {
      product.regularOffers.push({
        value: _managersSpecialDiscount,
        qty: 1,
        prices: {
          monthly: -5,
          oneTime: 0
        }
      });

      managerSpecialDiscount = 5;
    } else if (
      valueManagerSpecial === 'managerspecial$5' &&
      valueRegularYearlyPromoBundled === standaloneOffer &&
      validProvinces.includes(request.getProvince())
    ) {
      product.regularOffers.push({
        value: _managersSpecialDiscount,
        qty: 1,
        prices: {
          monthly: -5,
          oneTime: 0
        }
      });

      managerSpecialDiscount = 5;
    }

    if(valueManagerSpecialAB === 'managerspecial$5' &&
    (valueTerm === _valueTerm60Month || valueTerm === _valueTerm36Month) &&
    [mbps1G, mbps15G, 'Fibre Internet 3G: 3G/3GMbps', '3G/3000 mbps'].includes(
      valueQualifiedSpeed
    ) &&
    valueRegularYearlyPromoBundled === _bundled &&
    validProvinces.includes(request.getProvince())){

      product.regularOffers.push({
        value: _managersSpecialDiscount,
        qty: 1,
        prices: {
          monthly: -5,
          oneTime: 0
        }
      });

      managerSpecialDiscount = 5;

    }


    if (valueMppOffer) {
      if (valueMppOffer === mppCrossSellOffer15) {
        promoDiscount += yearlyFibreMppDiscounts.crossSellOffer15;
        product.limitedTimeOffers.push({
          value: partnerDiscount,
          qty: '',
          prices: {
            monthly: -yearlyFibreMppDiscounts.crossSellOffer15,
            oneTime: 0
          }
        });
      }
      if (valueMppOffer === mppFibreInternet1G) {
        promoDiscount += yearlyFibreMppDiscounts.mppFibreInternet1G;
        product.limitedTimeOffers.push({
          value: partnerDiscount,
          qty: '',
          prices: {
            monthly: -yearlyFibreMppDiscounts.mppFibreInternet1G,
            oneTime: 0
          }
        });
      }
    }
    if (valueLimitedYearlyOffer) {
      if (valueRegularYearlyPromoBundled === standaloneOffer) {
        product.limitedTimeOffers.push({
          value: getFieldPriceOrLabel(
            formStepFields,
            valueLimitedYearlyOffer,
            false
          ),
          qty: 1,
          prices: {
            monthly: -limitedYearlyOffersFibreStandalone[
              valueLimitedYearlyOffer
            ],
            oneTime: 0
          }
        });
        promoDiscount +=
          limitedYearlyOffersFibreStandalone[valueLimitedYearlyOffer] + 10;
      }
      if (valueRegularYearlyPromoBundled === _bundled) {
        product.bundledOffers.push({
          value: getFieldPriceOrLabel(
            formStepFields,
            valueLimitedYearlyOffer,
            false
          ),
          qty: 1,
          prices: {
            monthly: -limitedYearlyOffersFibreBundled[valueLimitedYearlyOffer],
            oneTime: 0
          }
        });
        promoDiscount +=
          limitedYearlyOffersFibreBundled[valueLimitedYearlyOffer] + 10;
      }
    }

    if (valueLimitedMonthlyOffer3 && !isAnyFreePromoSelected) {
      product.limitedTimeOffers.push({
        value: getFieldPriceOrLabel(
          formStepFields,
          valueLimitedMonthlyOffer3,
          false
        ),
        qty: 1,
        prices: {
          monthly: -yearlyLimited3GPromo[valueLimitedMonthlyOffer3],
          oneTime: 0
        }
      });
      promoDiscount += yearlyLimited3GPromo[valueLimitedMonthlyOffer3];
    }
    if (valueLimitedYearlyOffersFibreFiveG) {
      product.limitedTimeOffers.push({
        value: getFieldPriceOrLabel(
          formStepFields,
          valueLimitedYearlyOffersFibreFiveG,
          false
        ),
        qty: 1,
        prices: {
          monthly: -fibreInternet5gPromoDiscount,
          oneTime: 0
        }
      });
      promoDiscount +=
        fibreInternet5gPromoDiscount;
    }
    //handle rate of (Fibre Internet 75 Limited Offers updates - CBM and MPP) on summary page
    if (valueLimitedOfferFI) {
      product.limitedTimeOffers.push({
        value: getFieldPriceOrLabel(formStepFields, valueLimitedOfferFI, false),
        qty: 1,
        prices: {
          monthly: -limitedOfferFI[valueLimitedOfferFI],
          oneTime: 0
        }
      });
      promoDiscount += limitedOfferFI[valueLimitedOfferFI];
    }
    if (valueLimitedYearlyOffersFibre150) {
      product.limitedTimeOffers.push({
        value: getFieldPriceOrLabel(
          formStepFields,
          valueLimitedYearlyOffersFibre150,
          false
        ),
        qty: 1,
        prices: {
          monthly: -limitedYearlyOffersFibre150[
            valueLimitedYearlyOffersFibre150
          ],
          oneTime: 0
        }
      });
      promoDiscount +=
        limitedYearlyOffersFibre150[valueLimitedYearlyOffersFibre150];
    }
    if (
      (valueTerm === _valueTerm36Month || valueTerm === _valueTerm60Month) &&
      valueQualifiedSpeed &&
      valuelimitedYearlyOffersFibreAlbertaBC
    ) {
        product.limitedTimeOffers.push({
          value: getFieldPriceOrLabel(
            formStepFields,
            valuelimitedYearlyOffersFibreAlbertaBC,
            false
          ),
          qty: 1,
          prices: {
            monthly: -10,
            oneTime: 0
          }
        });
      promoDiscount += 10;
    }
    if (
      (valueTerm === _valueTerm36Month || valueTerm === _valueTerm60Month) &&
      valueQualifiedSpeed &&
      valuelimitedTimeOfferYearly15gAlbertaBC
    ) {
      product.limitedTimeOffers.push({
        value: getFieldPriceOrLabel(
          formStepFields,
          valuelimitedTimeOfferYearly15gAlbertaBC,
          false
        ),
        qty: 1,
        prices: {
          monthly: -20,
          oneTime: 0
        }
      });
      promoDiscount += 20;
    }
  
    if (
      (valueTerm === _valueTerm36Month || valueTerm === _valueTerm60Month) &&
      valueQualifiedSpeed &&
      valuelimitedTimeOfferYearly3g_3000AlbertaBC
    ) {
      product.limitedTimeOffers.push({
        value: getFieldPriceOrLabel(
          formStepFields,
          valuelimitedTimeOfferYearly3g_3000AlbertaBC,
          false
        ),
        qty: 1,
        prices: {
          monthly: -25,
          oneTime: 0
        }
      });
      promoDiscount += 25;
    }
    if (valueLimitedYearlyOffersFibre300) {
      product.limitedTimeOffers.push({
        value: getFieldPriceOrLabel(
          formStepFields,
          valueLimitedYearlyOffersFibre300,
          false
        ),
        qty: 1,
        prices: {
          monthly: -limitedYearlyOffersFibre300[
            valueLimitedYearlyOffersFibre300
          ],
          oneTime: 0
        }
      });
      promoDiscount +=
        limitedYearlyOffersFibre300[valueLimitedYearlyOffersFibre300];
    }
    if (
      valueProductSelectionFibre &&
      valueProductSelectionFibre.includes(fieldTelusBusinessWifiOption) &&
      valueQualifiedSpeed === valueQualifiedSpeed940mbps &&
      valueLimitedYearlyOffer === fieldFiberInternetG1promo
    ) {
      product.bundledOffers.push({
        value: getFieldPriceOrLabel(
          formStepFields,
          fieldTelusBusinessWifiOption,
          false
        ),
        qty: 1,
        prices: {
          monthly: -5,
          oneTime: 0
        }
      });
      promoDiscount += 5;
    }
  }
  if (
    valueTerm === _valueTerm36Month &&
    valueQualifiedSpeed === '3G/3000 mbps' &&
    valueRegularYearlyPromoBundled === _bundled &&
    valueProductSelectionFibre.includes(fieldTelusBusinessWifiOption) &&
    valueLimitedYearlyOffersFibre3G === '3 Months Free'
  ) {
    product.limitedTimeOffers.push({
      value: getFieldPriceOrLabel(
        formStepFields,
        valueLimitedYearlyOffersFibre3G,
        false
      ),
      qty: 1,
      prices: {
        monthly: -10,
        oneTime: 0
      }
    });
    promoDiscount += 10;
  }

  if (
    (valueTerm === _valueTerm36Month || valueTerm === _valueTerm60Month) &&
    valueProductSelectionFibre &&
    valueProductSelectionFibre.includes(fieldTelusBusinessWifiOption)
  ) {
    if (
      valueQualifiedSpeed === valueQualifiedSpeed15gFibre ||
      valueQualifiedSpeed === valueQualifiedSpeed3gFibre
    ) {
      product.bundledOffers.push({
        value: getFieldPriceOrLabel(
          formStepFields,
          fieldTelusBusinessWifiOption,
          false
        ),
        qty: 1,
        prices: {
          monthly:
            valueTerm === _valueTerm36Month
              ? -threeYearBusinessWifiRates[valueQualifiedSpeed]
              : -fiveYearBusinessWifiRates[valueQualifiedSpeed],
          oneTime: 0
        }
      });
      promoDiscount +=
        valueTerm === _valueTerm36Month
          ? threeYearBusinessWifiRates[valueQualifiedSpeed]
          : fiveYearBusinessWifiRates[valueQualifiedSpeed];
    }
  }

  promoDiscount = promoDiscount || 0;
  product.speed = {
    value: getFieldPriceOrLabel(formStepFields, valueQualifiedSpeed, false),
    qty: 1,
    prices: {
      monthly: speedRate,
      oneTime: 0
    }
  };

  product.wifiAccess.forEach(item => {
    wifiAccessMonthly += item.prices.monthly;
    wifiAccessOneTime += item.prices.oneTime;
  });

  return {
    ...product,
    totalMonthly:
      staticIPRate +
        speedRate -
        promoDiscount +
        wifiAccessMonthly +
        fibreInternet15gPromoDiscount +
        threeYearLtoPromoDiscount -
        managerSpecialDiscount >
      0
        ? staticIPRate +
          speedRate -
          promoDiscount +
          wifiAccessMonthly +
          threeYearLtoPromoDiscount +
          fibreInternet15gPromoDiscount -
          managerSpecialDiscount
        : 0,
    // totalMonthly: (staticIPRate + speedRate - promoDiscount + threeYearLtoPromoDiscount) > 0 ? (staticIPRate + speedRate - promoDiscount + threeYearLtoPromoDiscount) : 0,
    totalOneTime: wifiAccessOneTime - creditDiscount
  };
};
